<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;My Salary Reports</h5>
  </div>

<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-4">
        <div class="row">
          <label class="col-sm-5 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSlected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="row">
          <label class="col-sm-5 col-form-label"
            >Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClosing"
            >
              <option value="">Select Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [value]="closing.id"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>
      <div class="col-sm-2" *ngIf="showExportToExcelButton">
        <button
          (click)="exportToExcelClick()"
          class="btn btn-sm btn-block btn-outline-theme"
        >
          <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
        </button>
      </div>
    </div>
  </div>
  </div>

<br>
  <div *ngIf="reportList != null">
    <div class="container pt-1" id="mainContent">
    <app-salary
      [reportList]="reportList"
      [myReportIndicator]="true"
    ></app-salary>
  </div>
  </div>
</div>
